// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R1L01","name":"styles_name__dZyl-","phone":"styles_phone__6SSmr"};